import http from "@/http";
import eventBus from "@/events";
import Token from "@/token";

const Organization = {
    findAll: async function (ctx) {
        if(ctx) {
            const page = ctx.currentPage - 1 || 0;
            const size = ctx.perPage || 20;
            const sortDesc = ctx.sortDesc ? ',desc' : '';
            const sort = (ctx.sortBy || 'name') + sortDesc;
            const filter = ctx.filter ? ctx.filter : {};
            const pagination = {page, size, sort};
            const params = {...filter, ...pagination};
            const endpoint = Token.hasPermission('ORGANIZATION_LIST_ALL_PERMISSION') ? '/organizations/search/all' : '/users/search/userOrganizations';
            const resp = await http(endpoint, {params});
            eventBus.$emit('LIST_COUNT_ORGANIZATION_EVENT', resp.data.page.totalElements);
            return resp.data._embedded.organizations;
        } else {
            const resp = await http("/organizations/search/all");
            eventBus.$emit('LIST_COUNT_ORGANIZATION_EVENT', resp.data.page.totalElements);
            return resp.data._embedded.organizations;
        }
    },
    usersByOrganizationIds: function(ids) {
      return http.get(`/organizations/search/usersByOrganizationIds?ids=${ids.join(',')}`);
    },
    create: function(data) {
        return http.post('/organizations', data);
    },
    update: function (id, data) {
        const url = Token.hasPermission('ORGANIZATION_UPDATE_PERMISSION') ? '/organizations/' + id : 'users/current-user/organization/' + id;
        return http.patch(url, data);
    },
    findById(id) {
        const url = Token.hasPermission('ORGANIZATION_LIST_ALL_PERMISSION') ? '/organizations/' + id : 'users/current-user/organization';
        return http.get(url);
    },
    enable(id) {
        return http.patch('/organizations/' + id + '/enable')
    },
    disable(id) {
        return http.patch('/organizations/' + id + '/disable')
    },
    deleteById(id) {
        return http.delete('/organizations/' + id)
    },
    findByUserId(id) {
        return http.get('/users/' + id + '/organizations');
    },
    getUsers(id) {
      return http.get('/organizations/' + id + '/users');
    },
    findOrganizationProjects: function(id) { return http.get('undefined'.replace('{id}', id)); }
};

export default Organization;
